import { createSlice } from "@reduxjs/toolkit";
import { getClient } from "../reduxApi/clientReduxApi";

const clientSlice = createSlice({
    name: 'client',
    initialState: {
    status: 'idel',
    isFiltered: false,
    client: [],
    },
    reducers: {
         setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteClientAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.client.findIndex((item) => item.clients.ROWID === id);
                if (index !== -1) {
                    state.client.splice(index, 1);
                }
            });
        },     
        updateClientAction: (state, action) => {
            // console.log("action", action.payload)
            const index = state.client.findIndex((item) => item.clients.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.client.splice(index, 1, { clients: action.payload })
            }
        },
        addClientAction: (state, action) => {
            // console.log("Adding client:", action.payload); 
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID
            state.client.unshift({clients:temp});
          }
    },
    extraReducers: (builder) => {
        builder.addCase(getClient.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getClient.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                state.client = action.payload.data.clientData;
            })
    }
})
export const { deleteClientAction, updateClientAction, addClientAction,setFilteredStatus } = clientSlice.actions
export default clientSlice.reducer